import { sentryCreateRootOptions } from '@tlx/sentry';
import { initializeTourMe } from '@tlx/tourme-core';
import { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { initSalarySentry } from '@Util/sentry/sentry';
import { App } from './App';

initSalarySentry();
initializeTourMe();

// eslint-disable-next-line no-console
console.log(`[salary] deployed from tripletex-frontend (${__APP_VERSION__.slice(0, 7)} ${__APP_BUILD_DATE__})`);

const container = document.getElementById('root');

if (container !== null) {
    const root = ReactDOM.createRoot(container, sentryCreateRootOptions());
    root.render(createElement(App));
}
